class StudioComponent extends HTMLElement {
  constructor() {
    super()

    $(document).ready(() => {
      this.initialize();
    });
  }


  initialize() {
    this.quantity = this.querySelector('[data-product-quantity]');
    this.priceWrapper = this.querySelector('[data-product-price-wrapper]');
    this.dateProperty = this.querySelector('[data-date-property]');
    this.dateStartProperty = this.querySelector('[data-date-start-property]');
    this.dateEndProperty = this.querySelector('[data-date-end-property]');
    this.timeProperty = this.querySelector('[data-time-property]');
    this.variants = this.querySelectorAll('[data-variant]');
    this.price = this.variants[0].getAttribute('data-price');
    this.rentNowText = this.querySelector('[data-add-to-cart-text]');
    this.id = this.getAttribute('data-id');
    this.checked = this.querySelector('[data-variant]:checked')
    this.variantName = this.checked.id;
    this.indicator = this.querySelector('[data-variant-indicator]');
    this.loading = true;
    this.setVariantDates = this.setVariantDates.bind(this);
    this.blocks = [];

    this.startDate = moment(new Date()).utc();

    this.variantNames = []
    this.variants.forEach(variant => {
      const name = variant.id;
      if (this.variantNames.includes(name)) return;
      this.variantNames.push(name)
    })
    this.variantIds = []
    this.variants.forEach(variant => {
      const id = variant.value;
      if (this.variantIds.includes(id)) return;
      this.variantIds.push(id)
    })

    this.variants.forEach((variant, index) => {
      variant.addEventListener('click', (e) => {
        this.price = e.target.getAttribute('data-price');
        this.id = e.target.value
        this.createDatepicker();
        this.variantName = e.target.id;
        this.setVariantDates();
        this.disableVariants();

        if (this.startDate) {
          this.updateProductForm();
        }

        gsap.to(this.indicator, {
          x: this.indicator.getBoundingClientRect().width * index,
          opacity: 1,
          duration: 0.6,
          ease: 'expo.inOut'
        })
      })
    })

    this.createDatepicker();
  }

  disableVariants() {
    const currentBlocks = this.blocks.filter(block => moment.utc(block.date).isSame(this.startDate, 'day'))
    const timeslots = currentBlocks.reduce((acc, block) => {
      return [...acc, ...block.timeslots]
    }, []);

    let availableSlots = []
    timeslots.forEach(timeslot => {
      const start = moment(timeslot.start).utc().tz("America/Los_Angeles").format('hA');
      const finish = moment(timeslot.finish).utc().tz("America/Los_Angeles").format('hA');

      if (timeslot.available == 0) return;

      if (start == '8AM' && finish == '6PM') {
        availableSlots.push('All Day')
      }

      if (start == '8AM' && finish == '12PM') {
        availableSlots.push('8AM - 12PM')
      }

      if (start == '12PM' && finish == '4PM') {
        availableSlots.push('12PM - 4PM')
      }
    });

    if (availableSlots.includes('All Day') && (!availableSlots.includes('8AM - 12PM') && !availableSlots.includes('12PM - 4PM'))) {
      availableSlots = []
      this.isDisabled = true;
    }

    if (availableSlots.includes('All Day') && availableSlots.length == 2) {
      availableSlots = availableSlots.filter(slot => slot == 'All Day' ? null : slot);
      this.isDisabled = false;
    }

    if (availableSlots.includes('All Day') && availableSlots.includes('8AM - 12PM') && availableSlots.includes('12PM - 4PM')) {
      availableSlots = ['All Day', '8AM - 12PM', '12PM - 4PM']
      this.isDisabled = false;
    }

    if (!availableSlots.includes('All Day')) {
      availableSlots = []
      this.isDisabled = true
    }

    if (availableSlots.length >= 1) {
      this.isDisabled = false
    }

    if (availableSlots.length == 0) {
      this.updateProductForm();
    }

    this.variantNames.forEach((name, index) => {
      if (!availableSlots.includes(name)) {
        $('.variant').eq(index).addClass('disabled')
        $('[data-variant]').eq(index).prop('disabled', true);
      } else {
        $('.variant').eq(index).removeClass('disabled')
        $('[data-variant]').eq(index).prop('disabled', false);
      }
    })

    if (!availableSlots.length) {
      gsap.to(this.indicator, {
        opacity: 0,
        duration: 0.6,
        ease: 'expo.inOut'
      });
      this.updateProductForm()
    } else {
      if ($('.variant input:checked').is(':disabled')) {
        const firstActiveVariant = $(`.variant`).find(`[data-time='${availableSlots[0]}']`);
        const index = $('.variant').index(firstActiveVariant.closest('.variant'))
        this.price = firstActiveVariant.attr('data-price')
        this.updateProductForm();
        firstActiveVariant.prop('checked', true);

        gsap.to(this.indicator, {
          opacity: 1,
          x: this.indicator.getBoundingClientRect().width * index,
          duration: 0.6,
          ease: 'expo.inOut'
        })
      } else {
        gsap.to(this.indicator, {
          opacity: 1,
          duration: 0.6,
          ease: 'expo.inOut'
        })
      }
    }
  }

  setVariantDates() {
    if (!this.variantName || !this.startDate) return;
    const date = this.startDate.utc().format('YYYY-MM-DD');
    let start, end;

    if (this.variantName.includes('8AM')) {
      start = 'T08:00:00';
      end = 'T12:00:00';
      this.setStartDate(date + start)
      this.setEndDate(date + end)
    } else if (this.variantName.includes('4PM')) {
      start = 'T12:00:00';
      end = 'T16:00:00';
      this.setStartDate(date + start)
      this.setEndDate(date + end)
    } else if (this.variantName.includes('All Day')) {
      start = 'T08:00:00';
      end = 'T18:00:00';
      this.setStartDate(date + start)
      this.setEndDate(date + end)
    }

    this.createDatepicker();
    this.updateProductForm();
  }

  getBlocks(start, end) {
    return Promise.all(this.variantIds.map(id => {
      return fetch(`https://api.bookthatapp.com/v1/blocks?external_id=${id}&start=${start}&finish=${end}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6NjAyMTYsInNob3AiOiJwYWxldHRlLXN1cHBseSJ9.L3-ckRH6wtaJhUwzT4vlfI6K1WnCY2De76M3Bc6mOi0`
        }
      })
        .then(res => res.json())
    }
    ))
  }

  createDatepicker() {
    const datepicker = this.querySelector('#datepicker');
    const today = moment(new Date()).utc().format('YYYY-MM-DD');
    const future = moment(new Date()).utc().add(90, 'days').format('YYYY-MM-DD')

    if (this.datepicker) {
      return $(datepicker).datepicker('refresh');
    }

    this.promises = this.getBlocks(today, future)

    this.promises.then(res => {
      let allBlocks = [...res[0].blocks, ...res[1].blocks]
      this.blocks = allBlocks;

      const firstAvailable = allBlocks.find(block => block.available_slot_count > 0);
      if (firstAvailable) this.startDate = moment(firstAvailable.date).utc();

      $(document).on('product:refresh', () => {
        if (!this.startDate) return;
        this.getBlocks(this.startDate.subtract(30, 'days').format('YYYY-MM-DD'), this.startDate.add(60, 'days').format('YYYY-MM-DD'))
          .then(res => {
            allBlocks = [...res[0].blocks, ...res[1].blocks]
            this.blocks = [...res[0].blocks, ...res[1].blocks]
            this.disableVariants();
            $(datepicker).datepicker('refresh')
          })
      });

      this.loading = false;
      this.disableVariants();
      this.updateProductForm();
      this.datepicker = $(datepicker).datepicker({
        onChangeMonthYear: (year, month, inst) => {
          this.defaultDate = new Date(year, month, 1);
          const newDate = moment(new Date(year, month - 1, 1)).utc();
          this.getBlocks(newDate.subtract(30, 'days').format('YYYY-MM-DD'), newDate.add(90, 'days').format('YYYY-MM-DD'))
            .then(res => {
              allBlocks = [...res[0].blocks, ...res[1].blocks]
              this.blocks = [...res[0].blocks, ...res[1].blocks]
              $(datepicker).datepicker('refresh')
            })
        },
        beforeShowDay: (date) => {
          const sameDay = allBlocks && allBlocks.filter(block => moment.utc(block.date).isSame(moment.utc(date), 'day'));
          const dateIsNextTwoDays = moment.utc(date).isBefore(moment.utc(moment()).add(3, 'days'), 'day');
          let isAvailable = false;
          if (sameDay && this.hasAvailableTimeslot(sameDay) && !dateIsNextTwoDays) {
            isAvailable = true;
          }
          var className = this.shouldDateBeSelected(date) && isAvailable ? "active" : "";
          return [isAvailable, className];
        },
        minDate: 0
      });
      $('.ui-state-hover').removeClass('ui-state-hover')
      this.datepicker.on('change', function () {
        const date = this.value;
        handleChange(date);
      })
    })
      .catch(e => {
        console.error(e)
      });


    const handleChange = this.handleChange.bind(this);
  }

  hasAvailableTimeslot(blocks) {
    const availableBlock = blocks.find(block => block.available_slot_count >= 1);
    let isAvailable = !!blocks.length && !!blocks.find(block => block.available_slot_count >= 1);

    const filteredBlocks = blocks.reduce(
      (acc, block) => {
        return [...acc, ...block.timeslots]
      }, [])

    console.log(filteredBlocks)

    if (!availableBlock) return false;

    let availableSlots = []

    availableBlock.timeslots.forEach(timeslot => {
      const start = moment(timeslot.start).utc().tz("America/Los_Angeles").format('hA');
      const finish = moment(timeslot.finish).utc().tz("America/Los_Angeles").format('hA');

      if (timeslot.available == 0) return;

      if (start == '8AM' && finish == '6PM') {
        availableSlots.push('All Day')
      }

      if (start == '8AM' && finish == '12PM') {
        availableSlots.push('8AM - 12PM')
      }

      if (start == '12PM' && finish == '4PM') {
        availableSlots.push('12PM - 4PM')
      }
    });

    if (!availableSlots.includes('All Day')) {
      return false;
    }

    return isAvailable;
  }

  handleChange(date) {
    this.startDate = moment(new Date(date));
    this.setVariantDates();
    this.disableVariants();
    this.updateProductForm();
  }

  updateProductForm() {
    const start = this.startDate;
    const end = this.endDate;
    let quantity = 1;
    let dateString = '';

    if (!start || !end) {
      return;
    }

    if (start && this.variantName) {
      dateString = `${start.format('D MMM YYYY')}, ${this.variantName}`
    }

    // SET PRICE
    this.querySelector('[data-product-price]').innerHTML = `$${(this.price / 100) * quantity}`;
    this.rentNowText.innerHTML = 'Rent Now';
    this.priceWrapper.classList.remove('visually-hidden');
    this.dateProperty.value = dateString;
    this.dateStartProperty.value = start.tz("America/Los_Angeles").format('YYYY-MM-DTHH:mm');
    this.dateEndProperty.value = end.tz("America/Los_Angeles").format('YYYY-MM-DTHH:mm');
    this.timeProperty.value = start.format('LT');

    if (this.isDisabled) {
      this.priceWrapper.classList.add('visually-hidden');
      this.rentNowText.innerHTML = 'Not Available';
      this.rentNowText.parentElement.disabled = true;
    } else {
      this.rentNowText.parentElement.disabled = false;
    }
  }

  setStartDate(value) {
    this.startDate = moment(this.convertStringToJSDate(value));
  }

  setEndDate(value) {
    this.endDate = moment(this.convertStringToJSDate(value));
  }

  clearEndDate() {
    this.endDate = null;
  }

  clearStartDate() {
    this.startDate = null;
  }

  shouldDateBeSelected(date) {
    var startDate = this.startDate;

    if (!startDate) {
      return false;
    }

    if (!moment.isMoment(date)) {
      date = moment(date).utc();
    }

    if (startDate && date.isSame(startDate, 'day')) {
      return true;
    } else {
      return false;
    }
  }

  convertStringToJSDate(date, asMoment) {
    asMoment = asMoment || false;
    if (date.includes('T')) {
      return moment(date)
    }
    if (date) {
      var split = date.split("/");
      var day = split[1];
      var month = split[0] - 1;
      var year = split[2];
      if (asMoment) {
        return moment(new Date(year, month, day));
      } else {
        return new Date(year, month, day);
      }
    } else {
      return null;
    }
  }
}

customElements.define('studio-component', StudioComponent);